import React from 'react';
import { BsClipboard2Check } from 'react-icons/bs';
import SidebarFlyoutNavRow from './SidebarFlyoutNavRow';
import { ADMIN_FLYOUT_IDS } from './SidebarFlyoutContext';
import { buildProcurementFlyoutItems, PROCUREMENT_CHILD_ROUTES } from './procurement/procurementNavConfig';

function ProcurementFlyoutRow({ SubMenuItem, hasMenuAccess, closeMobileSidebar, indentClass = 'ps-5' }) {
  const items = buildProcurementFlyoutItems(hasMenuAccess);
  if (items.length === 0) return null;

  return (
    <SidebarFlyoutNavRow
      flyoutId={ADMIN_FLYOUT_IDS.procurement}
      label="Procurement"
      flyoutTitle="Procurement"
      items={items}
      SubMenuItem={SubMenuItem}
      closeMobileSidebar={closeMobileSidebar}
      indentClass={indentClass}
      alwaysFlyout
    />
  );
}

function ProcurementNavContent({ SubMenuItem, hasMenuAccess }) {
  return (
    <>
      {hasMenuAccess('/supply-chain/requisitions') && <SubMenuItem to="/supply-chain/requisitions">Requisitions</SubMenuItem>}
      {hasMenuAccess('/supply-chain/purchase-orders') && <SubMenuItem to="/supply-chain/purchase-orders">Purchase Orders</SubMenuItem>}
      {(hasMenuAccess('/supply-chain/approval-inbox') || hasMenuAccess('/supply-chain/requisitions')) && (
        <SubMenuItem to="/supply-chain/approval-inbox">Approval Inbox</SubMenuItem>
      )}
      {hasMenuAccess('/supply-chain/vendors') && <SubMenuItem to="/supply-chain/vendors">Vendors / Suppliers</SubMenuItem>}
    </>
  );
}

/**
 * Procurement block for the desktop sidebar (NavigationBar).
 * Under Administration: single flyout row (Drilling → Budget pattern).
 */
function ProcurementNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
  nested = false,
}) {
  if (!hasMenuAccessOrChild('/supply-chain', PROCUREMENT_CHILD_ROUTES)) {
    return null;
  }

  if (nested) {
    return (
      <ProcurementFlyoutRow
        SubMenuItem={SubMenuItem}
        hasMenuAccess={hasMenuAccess}
        closeMobileSidebar={closeMobileSidebar}
        indentClass="ps-5"
      />
    );
  }

  return (
    <MenuItem customIcon={<BsClipboard2Check style={{ width: '24px', height: '24px' }} />} title="Procurement" id="supply-chain">
      <ProcurementNavContent SubMenuItem={SubMenuItem} hasMenuAccess={hasMenuAccess} />
    </MenuItem>
  );
}

export default ProcurementNavSection;
